import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import {
  transformArticleData,
  transformCardImageBasedXLargeData,
} from '../../utils';
import CardImageBasedSmall from '../Cards/CardImageBased/CardImageBasedSmall';
import CardImageBasedXLargeFullWidth from '../Cards/CardImageBased/CardImageBasedXLargeFullWidth';
import TitleFeed from '../Titles/TitleFeed';
import TitleStrip from '../Titles/TitleStrip';

const TITLE = 'Life';
const LINK = {
  title: 'View All Life',
  url: '/life/',
};

const HomepageLife = ({ carousel: _carousel, description, profiles }) => {
  const carousel = transformCardImageBasedXLargeData(_carousel);
  return (
    <div
      className="maxed:mx-auto maxed:w-[1920px] border-t border-b maxed:border-r border-smoke bg-snow relative"
      data-module-id="homepage_life"
    >
      <div className="absolute top-0 bottom-0 left-0 z-30 w-2 sm:w-3 lg:w-4 bg-ocean" />
      <TitleStrip description={description} link={LINK} title={TITLE} />
      <div className="xl:w-[1440px] xl:mx-auto">
        <CardImageBasedXLargeFullWidth carousel={carousel} />
      </div>
      <div className="pt-8 sm:pt-10 lg:pt-18" />
      <TitleFeed title="Profiles" />
      <div className="mt-8 mb-12 sm:mb-10 lg:mb-18 gap-y-9 homepage-grid-container lg:mt-10">
        {profiles.map((item, index) => {
          const {
            cardImage,
            id,
            publishedDate,
            slug,
            tags,
            title: profileTitle,
          } = transformArticleData(item);
          const cutoff = index >= 4;
          return (
            <div
              key={id}
              className={classnames(
                'col-span-6',
                'sm:col-span-3',
                'lg:col-span-4',
                {
                  hidden: cutoff,
                  'lg:block': cutoff,
                },
              )}
            >
              <CardImageBasedSmall
                date={publishedDate}
                image={cardImage}
                slug={slug}
                tags={tags}
                title={profileTitle}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

HomepageLife.propTypes = {
  carousel: PropTypes.array,
  profiles: PropTypes.array,
};

export default HomepageLife;
